import Vue from 'vue'
import Url from '../zujian/Url.vue' 
Vue.component(Url.name,Url);
import Tijiao from '../zujian/Tijiao.vue' 
Vue.component(Tijiao.name,Tijiao); 

//设置域名
// Vue.prototype.$yuming='limitao.myuan.cn';//开发版
// Vue.prototype.$url='https://limitao.myuan.cn/houtai.php';
Vue.prototype.$yuming= process.env.VUE_APP_BASE_API;	//正式
Vue.prototype.$url= process.env.VUE_APP_BASE_API+'/houtai.php';

Vue.prototype.$tengxunditu='43BBZ-26IK5-ER3IV-QK32L-ZWHIO-HJFAA';
 Vue.prototype.$posts=function(_url,shu,fun){
	var that=this;
	var url ='http://goodwe.jsydl.com.cn:9200/invitation/home/forum';
		if(typeof(shu)=='function'){
			fun=shu;
			shu={}; 
		}

	this.$axios({
	    method:'get',
	    url:url,
	    data:shu,	  
	    headers:{			
			'kouling':that.$yonghu?that.$yonghu.kouling:''
		},	
	}).then(function(res){		
		if(res.data.shi==-1){
			localStorage.removeItem('yonghu');
			that.$dakai('denglu');
		}else if(res.data.shi==-100){
			if(!that.__zhixing){
				that.__zhixing=true;
				that.$xiaoxi(res.data.shu);	
				setTimeout(function(){
					that.__zhixing=false;
				},1000)
				that.$dakai('denglu');
			}			
		
		}else{
			fun(res.data);
		}
	    
	}).catch(function(err){
	    console.log(err);
	})
 }
 Vue.prototype.$post=function(_url,shu,fun){
	var that=this;
	var url =this.$url+'?'+_url;
		if(typeof(shu)=='function'){
			fun=shu;
			shu={}; 
		}

	this.$axios({
	    method:'POST',
	    url:url,
	    data:shu,	  
	    headers:{			
			'kouling':that.$yonghu?that.$yonghu.kouling:''
		},	
	}).then(function(res){		
		if(res.data.shi==-1){
			localStorage.removeItem('yonghu');
			that.$dakai('denglu');
		}else if(res.data.shi==-100){
			if(!that.__zhixing){
				that.__zhixing=true;
				that.$xiaoxi(res.data.shu);	
				setTimeout(function(){
					that.__zhixing=false;
				},1000)
				that.$dakai('denglu');
			}			
		
		}else{
			fun(res.data);
		}
	    
	}).catch(function(err){
	    console.log(err);
	})
 }

 Vue.prototype.$qu=function(key){	
    return JSON.parse(localStorage.getItem(key)) || [];
 }
 Vue.prototype.$cun=function(key,value){	
    return localStorage.setItem(key,JSON.stringify(value)) || '';
 }
 Vue.prototype.$dakai=function(url,canshu){
    // return this.$router.push(url).catch(err => {}) ;
	// return this.$router.push({path:url,query:canshu});
	if (url === '/login_in') {
	    // 优先保留手动传的canshu，再合并自动的redirect（避免覆盖手动传的参数）
	    // const finalParams = {
	    //   ...canshu, // 保留原有手动传的参数
	    //   redirect: this.$route.fullPath // 自动添加来源页路径
	    // };
		 // this.$cun('loginFromPath', this.$route.fullPath);
	    // return this.$router.push({ path: url, query: finalParams });
		   this.$cun('loginFromPath', this.$route.fullPath);
		    // 跳转登录页，不传任何参数（URL干净）
		    return this.$router.push({ path: url });
	  } else {
	    // 其他页面跳转，保持原有逻辑不变
	    return this.$router.push({ path: url, query: canshu });
	  }
 }
 Vue.prototype.$dakaiurl=function(url,canshu){
 	window.location.href=url;
 }
 Vue.prototype.$fuzhi=function(e,text){
    const clipboard = new this.clipboard(e.target, {
        text: () => text
    })
    clipboard.on('success', () => {
    	this.$xiaoxi('复制成功')
        // 释放内存
        clipboard.destroy()
    })
    clipboard.on('error', () => {
        // 不支持复制
    	this.$xiaoxi('复制失败')
        // 释放内存
        clipboard.destroy()
    })
    // 解决第一次点击不生效的问题，如果没有，第一次点击会不生效
    clipboard.onClick(e)
 }
 
 Vue.prototype.$shujuleixing = function(value) {
 	return Object.prototype.toString.apply(value).slice(8,-1);
 }
 
  Vue.prototype.$houtui=function(e){
	if(!e){
		e=-1;
	}
	return this.$router.go(e);
 }
 
 Vue.prototype.$xiaoxi=function(message,leixing){	
	if(leixing===0){
		return this.$message.error(message);
	}else{
		
		return this.$message({
		  showClose: true,
		  iconClass:'el-icon-warning',
		  customClass:'my-error-message',
		  message:message,
		  type: 'error',
		  offset:'350',
		  duration:0
		});
	}   
 }
 Vue.prototype.$suijizifu=function(len) {
　　len = len || 32;
　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
　　var maxPos = $chars.length;
　　var pwd = '';
　　for (var i = 0; i < len; i++) {
　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
　　}
　　return pwd;
}
 Vue.prototype.$quanju=function(jianzhi,zhi) {
	 if(jianzhi){
		if(!zhi)zhi=''; 
		 Vue.prototype[jianzhi]=zhi; 
	 }	 
}
Vue.prototype.$swoole=function(){	
		var that = this;
			
		// 初始化一个 WebSocket 对象
		Vue.prototype.$ws = new WebSocket('wss://im.myuan.cn:9503');

		// 建立 web socket 连接成功触发事件
		that.$ws.onopen = function() {
		  // 使用 send() 方法发送数据
		   // that.$ws.send('发送数据');
		  // alert('数据发送中...');
		};

		// 接收服务端数据时触发事件
		that.$ws.onmessage = function(evt) {
			// console.log(evt)
		  var received_msg = evt.data;
		  // alert('数据已接收...');
		};

		// 断开 web socket 连接成功触发事件
		that.$ws.onclose = function() {
			setTimeout(function(){
				that.$swoole();
			},3000)
		};

}

Vue.prototype.$fasong=function(shu){	
	var that=this;
	if(shu){
		shu=JSON.stringify(shu),
		that.$ws.send(shu);
	}
}
